import axios from "axios";

// Axios를 이용하여 인스턴스를 설정해 준다.
// baseURL로 설정하고 api_key와 languge를 파라미터로  줄 수 있다.
const api = axios.create({
  baseURL: "https://api.themoviedb.org/3/",
  params: {
    api_key: "6e6a3de56d7e4e0ff784cf0d24daa0dd",
    language: "ko-KR",
  },
});

// api.get을 이용하여 api의 key, language들을 전달해 준다.
// api.get안에 ("")에 들어갈 정보들은 원하는 것을 찾아 themoviedb에서
// 가져오는 형식을 보고 작성해 준다.
export const moviesApi = {
  nowPlaying: () => api.get("movie/now_playing"),
  upcoming: () => api.get("movie/upcoming"),
  popular: () => api.get("movie/popular"),
  movieDetail: (id) =>
    api.get(`movie/${id}`, {
      params: {
        append_to_response: "videos",
      },
    }),
  collection: (id) => api.get(`collection/${id}`),
  search: (term) =>
    api.get("search/movie", {
      params: {
        query: encodeURIComponent(term),
      },
    }),
};

export const tvApi = {
  topRated: () => api.get("tv/top_rated"),
  popular: () => api.get("tv/popular"),
  airingToday: () => api.get("tv/airing_today"),
  showDetail: (id) =>
    api.get(`tv/${id}`, {
      params: {
        append_to_response: "videos",
      },
    }),
  search: (term) =>
    api.get("search/tv", {
      params: {
        query: encodeURIComponent(term),
      },
    }),
};
